<div class="container-box p-3">
  <div class="bg-active2 p-3 rounded">
    <div class="text-semi-bold mb-3">
      <span class="badge badge-circle badge-light border text-md">1</span>
      <ng-container *ngIf="isOnetime" i18n> What type of document would you like to send? </ng-container>
      <ng-container *ngIf="!isOnetime" i18n> What type of template would you like to create? </ng-container>
    </div>

    <div class="select-block-container m-4">
      <div
        class="select-block"
        [class.active]="templateType === item.id"
        [class.disabled]="!isTypeEditable"
        [matTooltip]="item.tooltip"
        matTooltipPosition="below"
        *ngFor="let item of availableTemplateTypes"
      >
        <a (click)="onChangeType(item.id)">
          <i [ngClass]="item.id | templateIcon : true"></i>
          <div class="text-nowrap">{{ item.name }}</div>
        </a>
      </div>
    </div>
  </div>

  <div class="bg-active2 p-3 rounded mt-3">
    <div class="text-semi-bold mb-3">
      <span class="badge badge-circle badge-light border text-md">2</span>
      <ng-container *ngIf="isOnetime" i18n> Upload the file that will be used for the document.</ng-container>
      <ng-container *ngIf="!isOnetime" i18n> Upload the file that will be used for the template.</ng-container>
    </div>
    <div class="m-4">
      <app-template-uploader
        (uploaded)="onTemplateUpload($event)"
        [uploadedFilesData]="form.get('uploaded').value"
        [isOnetime]="isOnetime"
      ></app-template-uploader>
    </div>
  </div>
</div>
